import { render, staticRenderFns } from "./CommentsPanel.vue?vue&type=template&id=03a7ef3a&"
import script from "./CommentsPanel.vue?vue&type=script&lang=ts&"
export * from "./CommentsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports